import React, { useEffect, useState } from 'react';
import {
  Badge,
} from '@material-ui/core';

const ReportsBadge = (props) => {
    return <Badge badgeContent={Math.max(props.newReports*1,0)} color="error">Отчёты</Badge>
}
  
export default ReportsBadge;